<template>
  <svg
    class="app-icon"
    :class="[`app-icon--${name}`, sizeClass, { 'is-filled': isFilled }]"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    :fill="isFilled ? 'currentColor' : 'none'"
    :stroke="isFilled ? 'none' : 'currentColor'"
    :stroke-width="isFilled ? undefined : 1.75"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <template v-if="name === 'home'">
      <path d="M12.05 2.35a1.1 1.1 0 0 0-1.35.08L2.4 10.2a1 1 0 0 0-.28.7V20.1c0 .94.76 1.7 1.7 1.7h5.35c.58 0 1.05-.47 1.05-1.05v-5.2c0-.47.38-.85.85-.85h2.06c.47 0 .85.38.85.85v5.2c0 .58.47 1.05 1.05 1.05h5.35c.94 0 1.7-.76 1.7-1.7v-9.2a1 1 0 0 0-.28-.7l-8.3-7.77a1.1 1.1 0 0 0-.75-.28Z" />
    </template>
    <template v-else-if="name === 'calendar'">
      <rect x="3.5" y="5" width="17" height="15.5" rx="2" />
      <path d="M8 3.5v3M16 3.5v3M3.5 10h17" />
    </template>
    <template v-else-if="name === 'plus-circle'">
      <circle cx="12" cy="12" r="10" fill="currentColor" />
      <path fill="#fff" d="M10.85 6.9c0-.64.51-1.15 1.15-1.15s1.15.51 1.15 1.15v3.95h3.95c.64 0 1.15.51 1.15 1.15s-.51 1.15-1.15 1.15h-3.95v3.95c0 .64-.51 1.15-1.15 1.15s-1.15-.51-1.15-1.15v-3.95H6.9c-.64 0-1.15-.51-1.15-1.15s.51-1.15 1.15-1.15h3.95V6.9Z" />
    </template>
    <template v-else-if="name === 'arrow-left'">
      <path d="M19 12H5" />
      <path d="m11 6-6 6 6 6" />
    </template>
    <template v-else-if="name === 'close'">
      <path d="M6 6l12 12M18 6 6 18" />
    </template>
    <template v-else-if="name === 'chevron-right'">
      <path d="m9 5 7 7-7 7" />
    </template>
    <template v-else-if="name === 'chevron-down'">
      <path d="m5 9 7 7 7-7" />
    </template>
    <template v-else-if="name === 'menu'">
      <path d="M4 7h16M4 12h16M4 17h16" />
    </template>
    <template v-else-if="name === 'list'">
      <path d="M9 7h11M9 12h11M9 17h11" />
      <path d="M5 7h.01M5 12h.01M5 17h.01" />
    </template>
    <template v-else-if="name === 'info'">
      <circle cx="12" cy="12" r="8.25" />
      <path d="M12 11v5" />
      <path d="M12 8h.01" />
    </template>
    <template v-else-if="name === 'sign-out'">
      <path d="M10 12h10" />
      <path d="m16 8 4 4-4 4" />
      <path d="M14 20H7a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h7" />
    </template>
    <template v-else-if="name === 'spinner'">
      <path d="M12 3.75a8.25 8.25 0 1 1-7.14 4.125" />
    </template>
    <template v-else-if="name === 'google'">
      <path d="M21 12.2a9 9 0 1 1-3.1-6.9" />
      <path d="M21 12h-9" />
    </template>
    <template v-else-if="name === 'facebook'">
      <rect x="3.5" y="3.5" width="17" height="17" rx="3.5" />
      <path d="M13.5 19v-6.5H15.5l.4-2.5H13.5V8.7c0-.7.2-1.2 1.2-1.2H16V5.2c-.3 0-1.2-.2-2.2-.2-2.2 0-3.6 1.3-3.6 3.8V10H8.5v2.5H10.2V19h3.3Z" />
    </template>
    <template v-else-if="name === 'link'">
      <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" />
      <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" />
    </template>
    <template v-else-if="name === 'check'">
      <path d="M20 6 9 17l-5-5" />
    </template>
    <template v-else-if="name === 'pencil'">
      <path d="M12 20h9" />
      <path d="M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4Z" />
    </template>
  </svg>
</template>

<script>
import { defineComponent } from 'vue'

const ICONS = [
  'home',
  'calendar',
  'plus-circle',
  'arrow-left',
  'close',
  'chevron-right',
  'chevron-down',
  'menu',
  'list',
  'info',
  'sign-out',
  'spinner',
  'google',
  'facebook',
  'link',
  'check',
  'pencil'
]

export default defineComponent({
  name: 'Icon',
  props: {
    name: {
      type: String,
      required: true,
      validator: (value) => ICONS.includes(value)
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value)
    }
  },
  computed: {
    sizeClass() {
      return `is-${this.size}`
    },
    isFilled() {
      return this.name === 'home' || this.name === 'plus-circle'
    }
  }
})
</script>
